import React from 'react';
import { Menu } from 'lucide-react';

const MobileMenuButton = ({ onClick }) => {
  return (
    <button 
      onClick={onClick}
      className="md:hidden absolute top-2 right-4 z-50 p-3 text-white hover:text-gray-300 active:text-white focus:text-white focus:outline-none transition-colors"
      aria-label="Open menu"
    >
      <Menu size={24} />
    </button>
  );
};

export default MobileMenuButton;
